<template>
  <div>
    <b-modal ref="modal" size="lg" hide-footer :no-close-on-esc="true" :no-close-on-backdrop="true" :hide-header-close="true">
      <div class="close" @click="hide()">&times;</div>
      <div class="activity-title">
        Scheduling - <span>{{ activity.taskTitle }}</span>
      </div>
      <div class="modal-body-wrapper">
        <!-- Send now section -->
        <b-form-group>
          <b-form-radio-group id="radio-group-1" v-model="scheduleType" name="radio-options">
            <b-form-radio :aria-describedby="ariaDescribedby" name="some-radios" value="sendNow">Send activity now</b-form-radio>
            <div class="row pl-33" v-if="scheduleType === 'sendNow'">
              <div class="col-sm-4 p-0">
                <div class="">
                  <div class="scheduler-heading">
                    What is the completion window?
                    <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                      <i class="fa fa-info-circle p-1" @click="toggleCompletionModal(true)"></i>
                    </a>
                  </div>
                  <input type="number" min="1" class="form-control completion_window_days input-color" placeholder="Enter" v-model="completionWindow" />
                  days
                </div>
              </div>
            </div>
            <b-form-radio :aria-describedby="ariaDescribedby" name="some-radios" value="schedule">Schedule to send</b-form-radio>
          </b-form-radio-group>
          <div class="mt-5 schedule-container" v-if="scheduleType === 'schedule'">
            <div class="pb-8 scheduler-heading">
              With what frequency will your participant receive this activity?
            </div>
            <div
              :class="{
                selected_milestone: frequency && frequency.type && f.type === frequency.type,
                disabled_frequency: f.disabled
              }"
              class="milestone_card"
              :key="index"
              v-for="(f, index) in frequencies"
              v-on:click="selectUnselectFrequency(f)"
            >
              <span class="m-0 pt-5">{{ f.title }}</span
              ><i v-if="frequency && frequency.type && f.type === frequency.type" class="fa fa-check tick-icon circle-icon" aria-hidden="true"></i>
            </div>
            <div class="row">
              <div class="col-sm-4 p-0">
                <div class="pt-14">
                  <div class="scheduler-heading">
                    What is the completion window?
                    <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                      <i class="fa fa-info-circle p-1" @click="toggleCompletionModal(true)"></i>
                    </a>
                  </div>
                  <input type="number" min="1" class="form-control completion_window_days input-color" placeholder="Enter" v-model="completionWindow" />
                  days
                </div>
              </div>
            </div>
            <div class="pt-20">
              <div class="scheduler-heading">
                Select time period this survey should appear
                <!-- <span class="study_duration">Study ends on day {{ studyDuration }}</span> -->
              </div>
              <div class="pb-15" v-for="(item, index) in duration" :key="index">
                <div class="row fs-12 color_959fa4">
                  <div class="col-md-3 pl-0">Start</div>
                  <div class="col-md-6 pl-0 ml-20">End</div>
                </div>
                <div class="row">
                  <div class="col-md-1 pl-0 pr-0">
                    <span class="day_label">Day</span>
                  </div>
                  <div class="col-md-3 custom-control pl-0">
                    <input type="number" v-validate="'required|min_value:1'" name="startDay" min="1" class="form-control input-width" v-model="item.startDay" @input="isNumber()" />
                  </div>
                  <div class="col-md-1 pl-0 pr-0">
                    <span class="day_label">Day</span>
                  </div>
                  <div class="col-md-3 custom-control pl-0">
                    <input type="number" min="1" class="form-control input-width" v-validate="'required|min_value:1'" name="endDay" v-model="item.endDay" @input="isNumber()" />
                  </div>
                  <div class="col-md-3 pl-0 color_blue cursor_pointer pt-5 text-class" v-on:click="addAnotherDuration(index)" v-if="duration.length === index + 1">
                    Add another time period
                  </div>
                  <div class="col-md-2 pl-0 color_red cursor_pointer pt-5" v-on:click="removeDuration(index)" v-if="duration.length !== index + 1">
                    Remove
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-form-group>
      </div>
      <!-- Footer Section Starts -->
      <div class="btn-wrapper">
        <span>
          <input id="schedule-all-activities" class="schedule-all-activities" type="checkbox" v-model="setScheduleForAllActivities" />
          <label class="all-activities" for="schedule-all-activities">Set schedule for all activities</label>
        </span>
        <button class="btn send-btn" @click="checkValidation()" :disabled="!scheduleType">
          Save
        </button>
      </div>
      <!-- Footer Section Ends -->
    </b-modal>
    <!-- Completion Window Modal Dialog Start -->
    <div id="activity-scheduler-completion-window" class="modal modal-position fade" role="dialog" data-backdrop="false">
      <div class="modal-dialog modal-lg modal-dialog-own" role="downloadVideoModal">
        <div class="modal-content p-0">
          <div class="modal-body p-0">
            <!-- Modal content-->
            <div class="completion_modal-content">
              <div>
                <div class="row text-right">
                  <a class="cancelImage cursor_pointer" data-dismiss="modal">
                    <i class="fa fa-times" aria-hidden="true" @click="toggleCompletionModal(false)"></i>
                  </a>
                </div>
                <div class="example">
                  <p class="example-header">
                    When a task is assigned to the participant, you have the opportunity to set the window of completion for the task before it expires.
                  </p>
                  <div class="bg-milestone pb-40">
                    <p class="example-content text-center">
                      Example: A survey is assigned to a participant at study week 2, which for this participant happens to be a Wednesday, and a 3 day completion window has been set. The survey will be pushed to the participant on Wednesday and will be available through Friday. On Saturday morning, the survey will be removed from participant’s task list and will be reported as a missed task.
                    </p>
                    <div class="row milestone">
                      <div class="col-lg-2 ml-0 pl-0 mr-0 pr-0" v-for="(milestone, index) in exampleMileStone" :key="index">
                        <div class="text-center">{{ milestone.day }}</div>
                        <div class="milestone_box" :class="{ 'white-bg': milestone.day === 'Sat' }">
                          <div
                            class="circle"
                            v-if="milestone.class"
                            :class="{
                              'bg-green': milestone.day === 'Wed',
                              'bg-red': milestone.day === 'Sat'
                            }"
                          ></div>
                        </div>
                        <div class="text-center">{{ milestone.date }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop" @click="toggleCompletionModal(false)"></div>
    </div>
  </div>
</template>
<script>
import toastr from "toastr";
import _ from "lodash";
import swal from "sweetalert2";

export default {
  name: "ActivitySchedulerComponent",
  props: {
    activity: {
      type: Object,
      required: true
    },
    participantData: {
      type: Object,
      required: true
    }
  },
  watch: {
    activityData: {
      handler() {}
    }
  },
  data() {
    return {
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      activityData: this.activity,
      scheduleType: null,
      ariaDescribedby: "default",
      frequencies: [
        { type: "daily", title: "Daily", days: 1, disabled: false },
        { type: "weekly", title: "Weekly", days: 7, disabled: false },
        { type: "biweekly", title: "Every 2 Weeks", days: 14, disabled: false },
        { type: "monthly", title: "Monthly", days: 30, disabled: false },
        {
          type: "biannually",
          title: "Bi-annually",
          days: 182,
          disabled: false
        },
        { type: "annually", title: "Annually", days: 365, disabled: false }
      ],
      allowUntillDuration: false,
      setScheduleForAllActivities: false,
      advanceScheduleDays: 0,
      getDelayDays: 0,
      duration: [{ startDay: null, endDay: null }],
      frequency: { type: "" },
      completionWindow: null,
      studyDuration: 0,
      studyData: {}
    };
  },
  created() {
    this.getStudyDetails();
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.resetDataOnCloseModal();
      this.$refs.modal.hide();
    },
    selectUnselectFrequency(frequency) {
      this.frequency = frequency;
    },
    getStudyDetails() {
      const studyId = this.$route.params.studyId;
      this.$api.getStudyDataFact(studyId).then(
        response => {
          const studyData = (this.studyData = response.body);
          const sd = new Date(studyData.firstPatientEnrollDate).valueOf();
          const ed = new Date(studyData.firstPatientLastDate).valueOf();
          this.studyDuration = parseInt((this.getExactDayEpoch(ed) - this.getExactDayEpoch(sd)) / 1000 / 86400, 10);
          _.forEach(this.frequencies, val => {
            switch (val.type) {
              case "daily":
                val.disabled = this.studyDuration < 1;
                break;
              case "weekly":
                val.disabled = this.studyDuration < 7;
                break;
              case "biweekly":
                val.disabled = this.studyDuration < 15;
                break;
              case "monthly":
                val.disabled = this.studyDuration < 30;
                break;
              case "biannually":
                val.disabled = this.studyDuration < 180;
                break;
              case "annually":
                val.disabled = this.studyDuration < 365;
                break;
              default:
                break;
            }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    getExactDayEpoch(day) {
      const newDay = new Date(day);
      return new Date(newDay.getFullYear(), newDay.getMonth(), newDay.getDate(), 0, 0, 0).getTime();
    },
    checkValidation() {
      const scheduler = {};
      scheduler["taskId"] = this.activity.taskId;
      scheduler["taskTitle"] = this.activity.taskTitle;
      scheduler["studyDuration"] = this.studyDuration;
      let validScheduler = true;
      let allDaysList = null;
      let properList = null;
      let durationValues = null;
      let participantCurrentDay = 0;
      scheduler.completionWindow = this.completionWindow ? Number(this.completionWindow) : null;
      if (!this.scheduleType) {
        toastr.error("Please select a scheduling option");
      }
      switch (this.scheduleType) {
        case "sendNow":
          if (!scheduler.completionWindow || scheduler.completionWindow <= 0 || scheduler.completionWindow % 1 !== 0) {
            validScheduler = false;
            toastr.error("Please specify completion window with value greater than 0");
          } else if (this.studyDuration <= scheduler.completionWindow) {
            validScheduler = false;
            toastr.error("Specified completion window cannot exceed study duration");
          }
          if (validScheduler) {
            this.saveActivity(scheduler);
          }
          break;
        case "schedule":
          this.$validator.validateAll().then(() => {
            this.frequency = this.frequency ? this.frequency : { type: null, title: null, days: null };
            durationValues = _.map(this.duration, item => ({
              startDay: parseFloat(item.startDay),
              endDay: parseFloat(item.endDay)
            }));
            allDaysList = _.flatten(_.map(durationValues, o => [o.startDay, o.endDay]));
            properList = _.compact(allDaysList);
            properList = this.allowUntillDuration && properList % 2 === 0 ? _.dropRight(properList) : properList;
            participantCurrentDay = this.participantData.participantDetails.participantCurrentDay;
            if (this.studyData.screeningMilestoneAllowed) {
              participantCurrentDay = this.participantData.participantDetails.participantCurrentDay - this.studyData.screeningDuration;
            }
            if (!this.frequency.type || !scheduler.completionWindow) {
              toastr.error(!this.frequency.type ? "Please select a frequency" : "Please specify completion window");
            } else if (scheduler.completionWindow <= 0 || scheduler.completionWindow % 1 !== 0) {
              toastr.error("Completion window should be greater than 0 and cannot have decimals");
            } else if (scheduler.completionWindow > this.frequency.days) {
              toastr.error("Completion window cannot exceed the length of the frequency");
            } else if (allDaysList.length !== properList.length && !this.allowUntillDuration && allDaysList.length !== properList.length - 1 && !this.studyData.screeningMilestoneAllowed) {
              toastr.error("Start and End days should be greater than 0 and cannot have decimals");
            } else if (participantCurrentDay >= _.min(properList) || _.min(properList) === undefined) {
              toastr.error("Start and End days should be in greater than participant current day.");
            } else if (!this.isValidDay(allDaysList)) {
              toastr.error("End day should be greater than start day.");
            } else if (!this.isSorted(properList)) {
              toastr.error("Start and end days should be in increasing order.");
            } else if (_.uniq(properList).length !== properList.length) {
              toastr.error("Scheduled start and end days overlap. Please revise.");
            } else if (_.max(properList) > this.studyDuration) {
              toastr.error("Start and end day should be less than study duration");
            } else if (this.isNumber()) {
              toastr.error("Please do not enter a decimal value for start day and end day");
            } else {
              this.saveActivity(scheduler);
            }
          });
          break;
        default:
          break;
      }
    },
    isSorted(arr) {
      const len = arr.length - 1;
      for (let i = 0; i < len; ++i) {
        if (arr[i] > arr[i + 1]) {
          return false;
        }
      }
      return true;
    },
    isValidDay(arr) {
      const len = arr.length - 1;
      for (let i = 0; i < len; ++i) {
        if (arr[i] > arr[i + 1]) {
          return false;
        }
        i = i + 2;
      }
      return true;
    },
    saveSchedule(scheduler) {
      const field = {};
      field["type"] = this.scheduleType;
      field["completionWindow"] = this.completionWindow;
      field["taskId"] = scheduler.taskId;
      field["taskTitle"] = scheduler.taskTitle;
      field["studyDuration"] = this.studyDuration;
      field["advanceScheduleDays"] = 0;
      field["getDelayDays"] = 0;
      if (this.scheduleType === "schedule") {
        field["duration"] = [...this.duration];
        field["frequency"] = { type: this.frequency.type };
      }
      let data = null;
      /* If scheduler used for all selected activities */
      if (this.setScheduleForAllActivities) {
        data = {
          setScheduleForAllActivities: this.setScheduleForAllActivities,
          scheduler: { ...field },
          activity: null
        };
        data = _.cloneDeep(data);
      } else {
        /* If scheduler used for only this selected activity */
        data = {
          setScheduleForAllActivities: this.setScheduleForAllActivities,
          scheduler: null,
          activity: { ...this.activity, ...field }
        };
        data = _.cloneDeep(data);
      }

      this.$emit("activityIsScheduled", data);
      this.hide();
    },
    addAnotherDuration() {
      this.duration.push({ startDay: null, endDay: null });
      this.$forceUpdate();
    },
    removeDuration(index) {
      this.duration.splice(index, 1);
      this.$forceUpdate();
    },
    saveActivity(scheduler) {
      swal({
        title: "You are about to send this activity to the participant.<br> Are you sure you would like to continue?<br> This action cannot be undone.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B8C7CE",
        cancelButtonColor: "#34537D",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.saveSchedule(scheduler);
        }
      });
    },
    toggleCompletionModal(showModal) {
      if (showModal) {
        window.$("#activity-scheduler-completion-window").modal("show");
      } else {
        window.$("#activity-scheduler-completion-window").modal("hide");
      }
    },
    resetDataOnRadioToggle(event) {
      const radio = event.target.value;
      const setScheduleForAllActivities = this.setScheduleForAllActivities;
      this.resetAllData();
      this.scheduleType = radio;
      this.setScheduleForAllActivities = setScheduleForAllActivities;
    },
    resetDataOnCloseModal() {
      this.resetAllData();
    },
    resetAllData() {
      this.allowUntillDuration = false;
      this.setScheduleForAllActivities = false;
      this.advanceScheduleDays = 0;
      this.getDelayDays = 0;
      this.duration = [{ startDay: null, endDay: null }];
      this.frequency = { type: "" };
      this.completionWindow = null;
      this.scheduleType = null;
    },
    isNumber() {
      this.duration.filter(rec => {
        if (rec.startDay) {
          if (rec.startDay % 1 !== 0 || rec.startDay < 0) {
            rec.startDay = parseInt(rec.startDay);
          }
          rec.startDay = parseInt(rec.startDay);
        }
        if (rec.endDay) {
          if (rec.endDay % 1 !== 0 || rec.endDay < 0) {
            rec.endDay = parseInt(rec.endDay);
          }
          rec.endDay = parseInt(rec.endDay);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.close {
  float: right;
}

.activity-title {
  font-family: RobotoRegular;
  margin-bottom: 0px;
  font-size: 18px;
  font-weight: 600;
  padding-left: 11px;
  span {
    font-weight: normal;
  }
}
.modal-body-wrapper {
  padding-left: 12px;
}

.position-top {
  top: 31px;
}

/deep/ .modal-content {
  width: 1064px !important;
}

/deep/ .modal-header {
  display: none;
  border-bottom: none !important;
  padding-left: 30px !important;
}

/deep/ .modal-body {
  padding: 1.5rem 1rem 1rem 1rem;
}

/deep/ .modal-title {
  font-weight: bold !important;
  padding-left: 15px !important;
}

.btn-wrapper {
  float: right;
  margin: 21px 24px 18px 10px;
  border: unset !important;
  width: unset !important;
  span {
    position: relative;
    input[type="checkbox"] {
      width: 21.7px;
      height: 21.7px;
      margin-right: 3px;
      background-color: #d3dfe4;
    }

    .all-activities {
      font-family: RobotoRegular;
      font-size: 12px;
      font-weight: normal;
      margin-right: 11px;
      position: absolute;
      left: -183px;
      top: 2px;
    }
    .schedule-all-activities {
      position: absolute;
      top: 0px;
      left: -214px;
    }
  }
  .btn {
    padding: 7px 35px;
    font-family: "RobotoRegular";
    font-size: 14px;
    color: #4a4a4a;
    outline: none;
    &:hover {
      cursor: pointer;
    }
    &:active {
      outline: none;
      cursor: pointer;
    }
    &:disabled {
      opacity: 0.5;
    }
    &.send-btn {
      background-color: #4c8ce4;
      color: #fff;
    }
  }
}

.scheduler-heading {
  font-weight: 500;
  color: #4a4a4a;
  font-family: RobotoRegular;
  font-size: 14px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.study_duration {
  display: inline-block;
  color: #4c8ce4;
  background-color: #edf3fc;
  padding: 2px 5px;
  border-radius: 2px;
}
.completion_window_days {
  width: 130px;
  height: 40px;
  display: inline-block;
  margin: 7px 8px 4px 0;
}
.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.bg-milestone {
  background-color: #f5f8fa;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.disabled_frequency {
  pointer-events: none;
  background-color: #ddd !important;
  border-radius: 4px !important;
  min-height: 50px;
  min-width: 150px;
  color: #4a4a4a !important;
  display: inline-block;
  font-size: 13px !important;
  font-weight: bold !important;
  font-stretch: normal !important;
  font-style: normal !important;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.day_label {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #888;
  background-color: #fafafa;
  background-image: none;
  border: 1px solid #ccc;
}
.milestone {
  padding: 0px 12px 0px 120px;
}

.circle {
  width: 7px;
  height: 8px;
  background-color: white;
  border-radius: 100px;
  margin-left: 3px;
}

.milestone_card {
  cursor: pointer;
  min-width: 150px;
  border: solid 1px #d3dfe4;
  background-color: #fff;
  border-radius: 2px;
  display: inline-block;
  padding: 10px 10px;
  margin: 0 10px 10px 0;
  min-height: 50px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #d3dee3;
  font-family: RobotoRegular;
}
.selected_milestone {
  background-color: #32557a;
  border-radius: 4px;
  min-height: 50px;
  min-width: 150px;
  color: #fff;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  padding: 10px;
  .day_text {
    color: #ddd;
    font-size: 12px;
  }
  .circle-icon {
    background: #4c8ce4;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    text-align: center;
    line-height: 0px;
    vertical-align: middle;
    padding: 8px 8px 9px 9px;
    margin: 0px 0 0px 63px;
    display: inline;
  }
  .numberCircle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    margin: 0 0 0 50px;
    padding: 0px 9px 5px 10px;
    background-color: #4c8ce4;
    color: #fff;
    text-align: center;
    font: 25px Arial, sans-serif;
    .tick-icon {
      color: #fff;
      font-weight: 100 !important;
      font-size: 14px;
      font-stretch: normal;
      font-style: normal;
    }
  }
}

.pt-40 {
  padding-top: 40px !important;
}

.pt-13 {
  padding-top: 13px !important;
}

.pl-33 {
  padding-left: 33px;
}

.mt-75 {
  margin-top: 75px;
}

.mt-30 {
  margin-top: 30px;
}

.schedule-container {
  margin-left: 27px;
}

.form-control {
  border-radius: 2px;
}

.input-width {
  width: 130px;
  max-width: 95% !important;
}

.text-class {
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #4c8ce4;
}

.custom-control {
  flex: 0 0 15%;
}

.card {
  padding: 15px;
  color: black;
}

.input-color {
  background-color: #fff;
  border: 1px solid #c5d0d5;
  border-radius: 3px;
}

.cancelImage {
  color: #959fa4;
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 24px;
}

.milestone_box {
  border: 1px solid #34537d;
  width: 60px;
  height: 10px;
  padding-top: 1px;
  padding-bottom: 9px;
  border-radius: 100px;
  background-color: #34537d;
}

.bg-green {
  background-color: #2ecc71 !important;
}

.bg-red {
  background-color: #ff7171 !important;
}

/* Completion modal style */
#activity-scheduler-completion-window {
  .modal-dialog {
    width: 1000px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    bottom: fixed;
    z-index: 99999999 !important;
    position: fixed;
  }
}
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100 !important;
  background-color: #000;
  opacity: 0.5;
}
@media (min-width: 576px) {
  #activity-scheduler-completion-window .modal-dialog {
    margin: 13% auto;
  }
}
@media (min-width: 992px) {
  /deep/ .modal-lg {
    max-width: 1125px !important;
  }
}
/deep/ #radio-group-1 .custom-control {
  min-height: 2rem;
}
/deep/ #radio-group-1 .custom-control-inline {
  display: block !important;
  margin-top: 17px;
}
/deep/ #radio-group-1 .custom-control-label {
  padding-top: 1.8px;
  font-weight: normal;
  font-family: RobotoRegular;
  font-size: 15px;
  font-weight: normal;
  color: #492b2b;
}
/deep/ #radio-group-1 .custom-control-label::after {
  position: absolute;
  top: 0.26rem;
  left: 0px;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 72% 72%;
}
/deep/ .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: transparent;
  box-shadow: 0 0 0 1px #4c8ce4 !important;
}
/deep/ .custom-radio .custom-control-input ~ .custom-control-label::before {
  background-color: transparent;
  /* box-shadow: 0 0 0 1px #4c8ce4 !important; */
  border: none !important;
}
/deep/ .custom-radio .custom-control-label::before {
  border-radius: 100%;
  /* box-shadow: 0 0 0 1px #4c8ce4 !important; */
  background-color: white;
  width: 15px !important;
  height: 15px !important;
}
/deep/ .custom-radio .custom-control-label::after {
  border-radius: 100%;
  box-shadow: 0 0 0 2px #4c8ce4 !important;
  background-color: white;
  width: 13px !important;
  height: 13px !important;
}
/deep/ .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none !important;
  width: 7px !important;
  height: 7px !important;
  margin: 4px;
  background-color: #4c8ce4;
}
/deep/ .custom-radio .custom-control-input ~ .custom-control-label::after {
  border-radius: 100%;
  -webkit-box-shadow: 0 0 0 2px #b0bac9 !important;
  box-shadow: 0 0 0 1px #b0bac9 !important;
  background-color: white;
  width: 13px !important;
  height: 13px !important;
}
/deep/ .custom-control.custom-radio.custom-control-inline {
  min-width: 0px !important;
}
/deep/ .custom-control-label {
  padding-top: 0px !important;
}
@media (min-width: 768px) and (max-width: 991px) {
  /deep/ .modal-content {
    width: 750px !important;
  }
}
@media (min-width: 992px) and (max-width: 1111px) {
  /deep/ .modal-content {
    width: 850px !important;
  }
}
</style>
